module.exports = __webpack_public_path__ + "img/equity.22992f8a.png";